import Keycloak from "keycloak-js";
import { env } from "@/config/env";

/**
 * Single Keycloak instance shared across the app.
 *
 * Uses Authorization Code + PKCE against realm `docapp`, client `react-web`.
 * See docs/architecture-gui.md §1 for the overall auth flow.
 */
export const keycloak = new Keycloak({
  url: env.keycloak.url,
  realm: env.keycloak.realm,
  clientId: env.keycloak.clientId,
});

export const KC_ROLES = {
  PATIENT: "ROLE_PATIENT",
  DOCTOR: "ROLE_DOCTOR",
  ADMIN: "ROLE_ADMIN",
} as const;

export type KcRole = (typeof KC_ROLES)[keyof typeof KC_ROLES];

const APP_ROLE_SET = new Set<string>(Object.values(KC_ROLES));

/**
 * Realm roles from the JWT, plus {@link KC_ROLES.PATIENT} when Keycloak did not assign any
 * app role (empty list or only built-in names). Keeps the SPA aligned with the gateway's
 * {@code KeycloakRealmRoleConverter}.
 */
export function effectiveRealmRoles(
  realmAccessRoles: string[] | undefined,
): string[] {
  const raw = realmAccessRoles ?? [];
  const hasAppRole = raw.some((r) => {
    const n = r.startsWith("ROLE_") ? r : `ROLE_${r}`;
    return APP_ROLE_SET.has(n);
  });
  if (hasAppRole) {
    return raw;
  }
  return [...raw, KC_ROLES.PATIENT];
}
